import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useExcelDataLoader } from './useExcelDataLoader';
import { useExcelPreviewLoader } from './useExcelPreviewLoader';
import {
  setErrorRso,
  setFile,
  setGetFileRso,
  setValueForm,
} from '../store/actions/rsoImportActions';

const useRcoContainerEffect = (draftRSO) => {
  const dispatch = useDispatch();

  const { file } = useSelector((state) => state.rsoImportStore);

  const handleFileUpload = useExcelDataLoader();
  const handleFileChange = useExcelPreviewLoader();

  useEffect(() => {
    if (draftRSO) {
      dispatch(
        setGetFileRso({
          generatedData: draftRSO?.generatedData,
          generatedFileName: draftRSO?.generatedFileName,
        })
      );

      dispatch(setValueForm(draftRSO));

      if (draftRSO.workerData && draftRSO.workerFileName) {
        const base64ToArrayBuffer = (base64) => {
          const binaryString = atob(base64);
          const len = binaryString.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          return bytes;
        };

        const ab = base64ToArrayBuffer(draftRSO.workerData);
        const fileObj = new File([ab], draftRSO.workerFileName, {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        dispatch(setFile(fileObj));
      }
    }
  }, [dispatch, draftRSO]);

  useEffect(() => {
    if (file && draftRSO) {
      handleFileUpload(draftRSO.headerRow, draftRSO.firstRow);
      handleFileChange(file);
    }
  }, [file, handleFileUpload, draftRSO, handleFileChange]);

  useEffect(() => {
    dispatch(setErrorRso(null));
  }, [dispatch]);
};

export default useRcoContainerEffect;
